import React, { useState, useEffect } from 'react';
import { ErrorBoundary, styles } from './Shared';
import './index.css';

// IMPORT ALL MODULES
import GlobalMasters      from './GlobalMasters';
import TechnicalMasters   from './TechnicalMasters';
import AdminModule        from './Admin';
import StyleRegistry      from './StyleRegistry';
import CostingWorksheets  from './CostingWorksheets';
import CostingSummary     from './CostingSummary';
import ProductionPlanning from './ProductionPlanning';
import PartDNA            from './PartDNA';
import Workstation        from './Workstation';
import MarkerMaker        from './MarkerMaker';
import QualityControl     from './QualityControl';
import MaterialManagement from './MaterialManagement';
import VALibrary          from './VALibrary';
import SourcingModule     from './Sourcing';
import ChallanModule      from './ChallanModule';
import Chatbot            from './Chatbot';
import Dashboard          from './Dashboard';
import DataPad            from './DataPad';
import Finance            from './Finance';
import ProductionMonitor  from './ProductionMonitor';

const API_URL = 'https://nirvikalp.integrashion.com/api';

const MODULES = {
  MERCHANDISING: { label: 'MERCHANDISING', icon: '👔', pages: ['Style', 'Costing', 'Material'] },
  SOURCING:      { label: 'SOURCING',      icon: '🌐', pages: ['Sourcing', 'VALibrary'] },
  TNA:           { label: 'T&A',           icon: '📅', pages: ['TnA'] },
  PRODUCTION:    { label: 'PRODUCTION',    icon: '🏭', pages: ['Style', 'PartDNA', 'Workstation', 'MarkerMaker', 'Logistics', 'Material'] },
  MONITORING:    { label: 'MONITORING',    icon: '📊', pages: ['Monitor', 'SampleTracker', 'DataPad'] },
  QUALITY:       { label: 'QUALITY',       icon: '✅', pages: ['Quality'] },
  ADMIN:         { label: 'ADMIN',         icon: '⚙️',  pages: ['Admin'] },
  FINANCE:       { label: 'FINANCE',       icon: '💰',  pages: ['Finance'] },
};

// LOGIN
const LoginScreen = ({ onLogin }) => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    if (user === 'admin' && pass === 'Shayana123') {
      onLogin({ name: 'Super Admin', role: 'admin' });
    } else {
      setError('Invalid Credentials');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 style={{color:'#1f1f1f',textAlign:'center',marginBottom:'20px'}}>nirvikalp 4.0</h2>
        {error && <div style={{color:'red',marginBottom:'10px',textAlign:'center'}}>{error}</div>}
        <input className="login-input" placeholder="Username" value={user} onChange={e=>setUser(e.target.value)} />
        <input className="login-input" placeholder="Password" type="password" value={pass} onChange={e=>setPass(e.target.value)}
          onKeyDown={e=>e.key==='Enter'&&handleLogin()} />
        <button className="login-btn" onClick={handleLogin}>LOGIN</button>
      </div>
    </div>
  );
};

// MAIN APP
export default function App() {
  const [isLoggedIn, setIsLoggedIn]     = useState(false);
  const [currentUser, setCurrentUser]   = useState(null);
  const [activeModule, setActiveModule] = useState('DASHBOARD');
  const [activePage, setActivePage]     = useState('');
  const [currency, setCurrency]         = useState({ name: 'USD', rate: 1 });
  const [currentStyle, setCurrentStyle] = useState(null);
  const [markerStyle, setMarkerStyle]   = useState(null);
  const [styleView, setStyleView]       = useState('GALLERY');
  const [targetStyle, setTargetStyle]   = useState(null);
  const [activeBlock, setActiveBlock]   = useState('DASHBOARD');

  const [db, setDb] = useState({
    brands:[], fabrics:[], products:[], buyers:[], seasons:[],
    trimTypes:[], uoms:[], currencies:[{id:1,name:'USD',rate:1}],
    productionZones:[], machines:[], manualCodes:[], stoppages:[],
    seamLengths:[], difficulties:[], gsmRanges:[], allowances:[],
    mgmtStyles:[], timelines:[], stylePlans:[], costings:[],
    masterParts:[], qcLogs:[], vaLibrary:[],
    suppliers:[], sourcingProducts:[], allocations:[], costingInvites:[],
    users:[], challans:[], gatePasses:[],
    deliveryLogs:[], rmIndexLog:[], fabricSpecs:[], automationRatings:[],
    qcDetailed:[], trimsWastage:[], colorVariants:[], moqCompliance:[],
    freightCosts:[], locationGrades:[],
    lineBookings:[], productionLogs:[], supplierOBs:[], poSizeTable:[],
    shipmentLogs:[], sourcingQuotes:[],
    cutPlans:[],
    factoryLines:[], lineAllocations:[], styleMaster:[],
    financeData: [],
  });

  useEffect(() => {
    if (activePage === 'Costing') {
      const costingBlocks = ['DASHBOARD','SUMMARY','MATERIAL','TRIMS','VA','FINISHING','CM'];
      if (!costingBlocks.includes(activeBlock)) setActiveBlock('DASHBOARD');
    }
  }, [activePage]);

  useEffect(() => {
    fetch(`${API_URL}/get_all_data.php`)
      .then(res => res.text())
      .then(text => {
        const data = JSON.parse(text.trim().replace(/^\uFEFF/, ''));
        if (data) {
          setDb(prev => ({
            ...prev, ...data,
            masterParts:        data.parts              || [],
            qcLogs:             data.qcLogs             || [],
            vaLibrary:          data.vaLibrary          || [],
            mgmtStyles:         data.mgmtStyles         || [],
            deliveryLogs:       data.deliveryLogs        || [],
            rmIndexLog:         data.rmIndexLog          || [],
            fabricSpecs:        data.fabricSpecs         || [],
            automationRatings:  data.automationRatings   || [],
            qcDetailed:         data.qcDetailed          || [],
            trimsWastage:       data.trimsWastage        || [],
            colorVariants:      data.colorVariants       || [],
            moqCompliance:      data.moqCompliance       || [],
            freightCosts:       data.freightCosts        || [],
            locationGrades:     data.locationGrades      || [],
            lineBookings:       data.lineBookings        || [],
            productionLogs:     data.productionLogs      || [],
            supplierOBs:        data.supplierOBs         || [],
            poSizeTable:        data.poSizeTable         || [],
            shipmentLogs:       data.shipmentLogs        || [],
            sourcingQuotes:     data.sourcingQuotes      || [],
            cutPlans:           data.cutPlans            || [],
            factoryLines:       data.factoryLines        || [],
            lineAllocations:    data.lineAllocations     || [],
            styleMaster:        data.styleMaster         || [],
            financeData:        data.financeData         || [],
          }));
        }
      })
      .catch(err => console.error('Data Load Error:', err));
  }, []);

  const saveToDB = async (category, data) => {
    try {
      const res = await fetch(`${API_URL}/save_universal.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ category, data }),
      });
      const result = await res.json();
      if (!result.success) throw new Error(result.error || 'Unknown error');
      return result;
    } catch (error) {
      console.error('DB Save Error:', error);
      alert('Database Save Failed: ' + error.message);
      return null;
    }
  };

  useEffect(() => {
    const handleUpdate = () => {
      fetch(`${API_URL}/get_all_data.php`)
        .then(r => r.text())
        .then(text => {
          const fresh = JSON.parse(text.trim().replace(/^\uFEFF/, ''));
          if (fresh) setDb(prev => ({ ...prev, ...fresh, masterParts: fresh.parts || [] }));
        }).catch(() => {});
    };
    window.addEventListener('nirvikalp_update', handleUpdate);
    return () => window.removeEventListener('nirvikalp_update', handleUpdate);
  }, []);

  const [ws, setWs] = useState({
    styleId: null, material: [], trims: [], va: [], finishing: [],
    cm: { sam:20, eff:65, cpm:0.15, cost:0 },
    comm: { oh:5, profit:10 }, status: 'Pending IA',
  });

  const saveCosting = async () => {
    if (!currentStyle) return alert('No style selected!');
    const newEntry = { styleId: currentStyle.id, lastUpdated: new Date().toISOString(), data: ws };
    setDb(p => ({ ...p, costings: [...p.costings.filter(c => c.styleId !== currentStyle.id), newEntry] }));
    await saveToDB('costing', { styleId: currentStyle.id, sheetData: ws });
    alert('Costing Saved!');
  };

  const loadCosting = (styleId) => {
    const style = db.mgmtStyles.find(s => s.id === styleId);
    if (!style) return;
    setCurrentStyle(style);
    const saved = db.costings.find(c => c.styleId === styleId);
    if (saved) setWs(saved.data || saved.worksheet_data);
    else setWs({ styleId, material:[], trims:[], va:[], finishing:[], cm:{sam:20,eff:65,cpm:0.15,cost:0}, comm:{oh:5,profit:10}, status:'Pending IA' });
  };

  const deleteCosting = (styleId) => {
    if (window.confirm('Reset costing?')) {
      setDb(p => ({ ...p, costings: p.costings.filter(c => c.styleId !== styleId) }));
      setWs({ ...ws, status: 'Pending IA' });
    }
  };

  const openStylePassport = (style) => {
    setTargetStyle(style); setStyleView('PASSPORT');
    setActiveModule('MERCHANDISING'); setActivePage('Style');
  };

  const calculateTotals = () => {
    const sum = (arr) => arr.reduce((a, b) => a + (parseFloat(b.total) || 0), 0);
    const mCost = sum(ws.material), tCost = sum(ws.trims), vCost = sum(ws.va), fCost = sum(ws.finishing);
    const cmVal = ws.cm.cost > 0 ? parseFloat(ws.cm.cost) : (ws.cm.sam * ws.cm.cpm) / (ws.cm.eff / 100);
    const subTotal = mCost + tCost + vCost + fCost + cmVal;
    const fobTotal = subTotal * (1 + (parseFloat(ws.comm.oh) + parseFloat(ws.comm.profit)) / 100);
    return { fobTotal };
  };

  const { fobTotal } = calculateTotals();
  const formatC = (v) => `${currency.name} ${(parseFloat(v) || 0).toFixed(2)}`;

  // ROUTER
  const renderContent = () => {
    switch (activePage) {
      case 'Style':
        return <StyleRegistry db={db} setDb={setDb} saveToDB={saveToDB}
          setActiveTab={()=>{}} setActiveBlock={setActiveBlock}
          loadCosting={loadCosting} currency={currency} view={styleView}
          setView={setStyleView} targetStyle={targetStyle}
          setTargetStyle={setTargetStyle} />;
      case 'Costing':
        return (activeBlock === 'SUMMARY' || activeBlock === 'DASHBOARD')
          ? <CostingSummary db={db} ws={ws} setWs={setWs} currency={currency}
              setCurrency={setCurrency} activeBlock={activeBlock}
              setActiveBlock={setActiveBlock} fobTotal={fobTotal}
              formatC={formatC} saveCosting={saveCosting}
              loadCosting={loadCosting} deleteCosting={deleteCosting}
              openStylePassport={openStylePassport} />
          : <CostingWorksheets db={db} ws={ws} setWs={setWs}
              activeBlock={activeBlock} setActiveBlock={setActiveBlock}
              saveCosting={saveCosting} currentStyle={currentStyle}
              currency={currency} openStylePassport={openStylePassport} />;
      case 'Material':
        return <MaterialManagement db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'Sourcing':
        return <SourcingModule db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'VALibrary':
        return <VALibrary db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'TnA':
        return <ProductionPlanning db={db} setDb={setDb} saveToDB={saveToDB} openStylePassport={openStylePassport} />;
      case 'PartDNA':
        return <PartDNA db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'Workstation':
        return <Workstation db={db} setDb={setDb} saveToDB={saveToDB}
          onOpenMarkerMaker={(style) => { setMarkerStyle(style); setActivePage('MarkerMaker'); }} />;
      case 'MarkerMaker':
        return <MarkerMaker db={db} preloadStyle={markerStyle}
          onClose={() => { setMarkerStyle(null); setActivePage('Workstation'); }} />;
      case 'Logistics':
        return <ChallanModule db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'Quality':
        return <QualityControl db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'Admin':
        return <AdminModule db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'Monitor':
        return <ProductionMonitor db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'SampleTracker':
        return <ProductionPlanning db={db} setDb={setDb} saveToDB={saveToDB}
          initialTab="TRACKER" />;
      case 'DataPad':
        return <DataPad db={db} setDb={setDb} saveToDB={saveToDB} />;
      case 'Finance':
        return <Finance db={db} setDb={setDb} saveToDB={saveToDB} />;
      default:
        return <div style={{padding:20, textAlign:'center'}}>Select a Page from the Menu</div>;
    }
  };

  if (!isLoggedIn) return <LoginScreen onLogin={u => { setIsLoggedIn(true); setCurrentUser(u); }} />;

  return (
    <ErrorBoundary>
      <div className="app-shell">
        <header className="nav-tier-1">
          <div className="brand-zone" onClick={()=>{setActiveModule('DASHBOARD'); setActivePage('');}}>
            <span style={{fontSize:'1.5rem'}}>🦁</span>
            <div style={{lineHeight:'1.1'}}>
              <div style={{fontWeight:'900',fontSize:'1.2rem',color:'#fff'}}>nirvikalp 4.0</div>
            </div>
          </div>
          <nav className="nav-1-links">
            {Object.entries(MODULES).map(([key, mod]) => (
              <button key={key}
                className={`nav-btn-1 ${activeModule === key ? 'active' : ''}`}
                onClick={() => { setActiveModule(key); setActivePage(mod.pages[0]); }}>
                <span>{mod.icon}</span> {mod.label}
              </button>
            ))}
          </nav>
          <div className="user-zone">
            <div style={{textAlign:'right',marginRight:'5px'}}>
              <div style={{fontSize:'0.9rem',fontWeight:'bold'}}>{currentUser?.name}</div>
              <div style={{fontSize:'0.7rem',opacity:0.7,textTransform:'uppercase'}}>{currentUser?.role}</div>
            </div>
            <button className="logout-btn" onClick={()=>setIsLoggedIn(false)}>LOGOUT</button>
          </div>
        </header>

        {activeModule !== 'DASHBOARD' && (
          <nav className="nav-tier-2">
            {MODULES[activeModule].pages.map(page => (
              <button key={page} className={`nav-btn-2 ${activePage === page ? 'active' : ''}`}
                onClick={() => setActivePage(page)}>
                {page.toUpperCase()}
              </button>
            ))}
          </nav>
        )}

        <main className="view-stage" style={{flex:1, overflow:'auto', minHeight:0, display:'block'}}>
          {activeModule === 'DASHBOARD' ? (
            <Dashboard db={db} onNavigate={(modKey) => { setActiveModule(modKey); setActivePage(MODULES[modKey].pages[0]); }} />
          ) : (
            renderContent()
          )}
          <Chatbot db={db} currentModule={activeModule} />
        </main>
      </div>
    </ErrorBoundary>
  );
}
